import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';
import { amplifyConfiguration } from './amplify-configuration';

export const initAmplify = () => {
  Amplify.configure(amplifyConfiguration);

  cognitoUserPoolsTokenProvider.setKeyValueStorage(
    new CookieStorage({
      expires: 1,
      sameSite: 'strict',
      secure: true,
    }),
  );
};
